import { render } from "./StrikeTheLetter.vue?vue&type=template&id=aabfdaae&scoped=true"
import script from "./StrikeTheLetter.vue?vue&type=script&lang=js"
export * from "./StrikeTheLetter.vue?vue&type=script&lang=js"

import "./StrikeTheLetter.vue?vue&type=style&index=0&id=aabfdaae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aabfdaae"]])

export default __exports__